import React from 'react';
import { FiAlertCircle, FiX } from 'react-icons/fi';

export const OrganogramDeleteModal = ({
  isOpen,
  position,
  onConfirm,
  onCancel,
  isSubmitting = false,
}) => {
  if (!isOpen || !position) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-sm w-full mx-4">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-red-100 rounded-full">
              <FiAlertCircle className="text-red-600" size={24} />
            </div>
            <h2 className="text-xl font-semibold text-gray-900">Delete Position</h2>
          </div>
          <button onClick={onCancel} className="p-1 hover:bg-gray-100 rounded transition-colors">
            <FiX size={24} />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <div>
            <p className="text-gray-700 font-medium mb-2">Are you sure you want to delete this position?</p>
            <p className="text-gray-600 text-sm mb-3">
              <strong>{position.positionName}</strong>
            </p>
            <p className="text-gray-600 text-sm">
              This action cannot be undone. Make sure no employees are assigned to this position before deleting.
            </p>
          </div>

          {position.assignedEmployeeCount > 0 && (
            <div className="bg-yellow-50 border border-yellow-200 rounded p-3">
              <p className="text-sm text-yellow-800">
                ⚠️ This position has {position.assignedEmployeeCount} employee
                {position.assignedEmployeeCount !== 1 ? 's' : ''} assigned. Please unassign them first.
              </p>
            </div>
          )}
        </div>

        <div className="flex gap-3 p-6 border-t border-gray-200">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors disabled:opacity-50"
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isSubmitting || position.assignedEmployeeCount > 0}
            className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50"
          >
            {isSubmitting ? 'Deleting...' : 'Delete Position'}
          </button>
        </div>
      </div>
    </div>
  );
};
